/** A timed-out mutation may have committed. Never retry it automatically. */
export async function semanticReviewRequest(
  url: string,
  options: RequestInit = {},
  timeoutMs = 15000,
): Promise<any> {
  const controller = new AbortController();
  let timedOut = false;
  const abort = () => controller.abort();
  if (options.signal?.aborted) controller.abort();
  else options.signal?.addEventListener("abort", abort, { once: true });
  const timer = setTimeout(() => {
    timedOut = true;
    controller.abort();
  }, timeoutMs);
  try {
    const response = await fetch(url, {
      ...options,
      credentials: "include",
      signal: controller.signal,
    });
    const payload = await response.json();
    if (!response.ok) throw Error(payload.message || "Review request failed");
    return payload;
  } catch (error) {
    if (timedOut)
      throw Error(
        "The request timed out. Refresh to confirm whether your action completed before trying again.",
      );
    throw error;
  } finally {
    clearTimeout(timer);
    options.signal?.removeEventListener("abort", abort);
  }
}
